<template>
  <el-dialog
    modal-append-to-body
    append-to-body="true"
    class="notice-dialog-wrap"
    :visible.sync="dialogVisible"
    width="450px"
    :before-close="handleClose">
    <div class="notice-wrapper">
      <img class="notice-laba" src="@/assets/img/laba.png" alt="">
      <img class="notice-xuxian" src="@/assets/img/xuxian.png" alt="">
      <div class="notice-title">{{i18n['screen.notice.title']||'运维公告'}}</div>
      <el-scrollbar>
        <div class="content board">{{config.noticeContent}}</div>
      </el-scrollbar>
      <div class="notice-btn">
        <el-button size="small" plain round @click="handleClose" :style="{color:`#${config.schemeColor}`,borderColor:`#${config.schemeColor}`,opacity:'0.8'}">{{i18n['screen.notice.button.close']||'我知道了'}}</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: [
    'i18n',
    'config',
    'dialogVisible',
  ],
  data: function data() {
    return {
    }
  },
  created: function created() {
  },
  mounted: function mounted() {
  },
  methods:{
    handleClose: function handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>